import React from "react";
import axios from "axios";
import StyledTable from "../../common/StyledTable";
import moment from "moment";
import "moment/locale/es";
import Swal from "sweetalert2";
import Button from "@material-ui/core/Button";
import PostulacionContainer from "./PostulacionContainer";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";
import {makeStyles} from "@material-ui/core/styles";
import {
  handleDownloadFileError,
  handleLoadingConcursoError,
} from "../../utils/errors";

const useStyles = makeStyles((theme) => ({
  backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
  },
}));

const ConcursosFacultad = (props) => {
  const classes = useStyles();
  const [openSpinner, setOpenSpinner] = React.useState(false);
  if (props.loading) {
    return <StyledTable loading />;
  }
  if (!props.visible) {
    return (
      <div
        style={{
          paddingTop: "1em",
          paddingLeft: "2em",
          paddingRight: "2em",
        }}
      >
        <p>No hay concursos disponibles.</p>
      </div>
    );
  }

  return (
    <div className="mt-4">
      {props.concursosFacultad.map((facultad, index) => {
        return (
          <React.Fragment key={index}>
            <div>
              <h5 className="mb-2">
                {facultad.nombre_facultad ? facultad.nombre_facultad : ""}
              </h5>
              <div id={facultad.nombre_facultad + "LT"}>
                <Concurso
                  key={facultad.nombre_facultad}
                  rows={facultad.data.map((concurso) =>
                    filaConcurso({
                      codigo: concurso.codigo,
                      nombre: concurso.nombre,
                      apertura: concurso.fecha_inicio,
                      cierre: concurso.fecha_termino,
                      concursoId: concurso.id,
                      numPostulantes: 0,
                      creador: concurso.id_usuario_creador,
                      contacto: concurso.id_usuario_contacto,
                      publicacion: concurso.fecha_aviso_diario,
                      facultades: props.facultades,
                      openSpinner: setOpenSpinner,
                    })
                  )}
                />
              </div>
            </div>
            <Backdrop className={classes.backdrop} open={openSpinner}>
                <CircularProgress color="inherit"/>
            </Backdrop>
          </React.Fragment>
        );
      })}
    </div>
  );
};

const Concurso = (props) => {
  const rows = props.rows;
  const headers = [
    { content: "Código" },
    { content: "Nombre" },
    { content: "Fecha de Apertura" },
    { content: "Fecha de Cierre" },
    { content: "Acciones" },
  ];

  return <StyledTable headers={headers} rows={rows} />;
};

const filaConcurso = (props) => {
  const aperturaDate = props.apertura ? new Date(new Date(props.apertura).getTime()) : undefined;
  const aperturaDateLocal = aperturaDate ? new Date(aperturaDate).toISOString().substring(0, 19) : undefined;
  const cierreDate = props.cierre ? new Date(new Date(props.cierre).getTime()) : undefined;
  const cierreDateLocal = cierreDate ? new Date(cierreDate).toISOString().substring(0, 19) : undefined;

  const fechaApertura = moment(aperturaDateLocal).locale("es").format("LLL");
  const fechaPublicacion = moment(props.publicacion).locale("es").format("LL");
  const fechaCierre = moment(cierreDateLocal).locale("es").format("LLL");

  return [
    { content: props.codigo, style: { width: "1px" } },
    { content: props.nombre },
    { content: fechaApertura, style: { width: "193px" } },
    { content: fechaCierre, style: { width: "193px" } },
    {
      content: (
        <div className="d-flex justify-content-around">
          <Button
            title={"Descargar documentos adjuntos"}
            onClick={() => handleDownloadFilesClick(props)}
            style={{ width: "120px" }}
          >
            Descargar Documentos
          </Button>
        </div>
      ),
      style: { width: "117px" },
    },
  ];
};

const handleDownloadFilesClick = (props) => {
  props.openSpinner(true)
  axios({
    url: window.ENV.API_URL + "/archivosConcurso/" + props.concursoId,
    method: "GET",
    responseType: "blob", // important
  })
    .then((response) => {
      props.openSpinner(false)
      if (response.status === 204) {
        return Swal.fire({
          icon: "warning",
          text: " El concurso no presenta documentos adjuntos",
        });
      }
      const file = new Blob([response.data], {
        type: "application/zip",
      });
      const fileURL = URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = "Documentos " + props.codigo;
      link.click();
    })
    .catch((error) => { 
      props.openSpinner(false);
      handleDownloadFileError(error);
    });
};

const PostulacionList = (props) => {
  const [concursos, setConcursos] = React.useState([]);
  const [loadingConcursos, setLoadingConcursos] = React.useState(true);

  React.useEffect(() => {
    let api_route = "/historialPostulacion/";

    axios
      .get(window.ENV.API_URL + api_route)
      .then((res) => {
        setConcursos(res.data);
        setLoadingConcursos(false);
      })
      .catch((error) =>
        handleLoadingConcursoError(
          error,
          window.ENV.URL_FRONT + "HistorialConcursos"
        )
      );
  }, []);

  return (
    <PostulacionContainer
      related={[
        { name: "Manual del usuario", to: "https://centraldearchivos.uchile.cl/download?token=88a5b941-c066-4bc3-9a29-9eef645551c9" },
        { name: "Concursos vigentes", to: "/ListaConcursos" },
      ]}
    >
      <ConcursosFacultad
        loading={loadingConcursos}
        visible={concursos.length > 0}
        concursosFacultad={concursos}
      />
    </PostulacionContainer>
  );
};

export default PostulacionList;
